import dayjs from 'dayjs'

import { computeDefaultReminder } from '../lib/dueDatePresets'

import DateTimeMenu from './DateTimeMenu'
import QuickPill from './QuickPill'

// Mirrors DueControl. Works with or without a due date; the relative quick
// options (Day of / before) only appear once a due date is set.
const ReminderControl = ({ dueDate, reminderDate, onChange }) => {
  // Ordered by ascending lead time before the due date; "Day of" (the morning-of
  // default) sits last since it isn't a fixed "X before" offset.
  const quickOptions = dueDate
    ? [
        {
          label: '10m before',
          getValue: () => dayjs(dueDate).subtract(10, 'minute').toDate(),
        },
        {
          label: '1h before',
          getValue: () => dayjs(dueDate).subtract(1, 'hour').toDate(),
        },
        {
          label: '1d before',
          getValue: () => dayjs(dueDate).subtract(1, 'day').toDate(),
        },
        { label: 'Day of', getValue: () => computeDefaultReminder(dueDate) },
      ]
    : []

  return (
    <div className="flex flex-col items-end gap-2">
      <DateTimeMenu
        value={reminderDate}
        onChange={onChange}
        placeholder="No Reminder Date"
        minDate={new Date()}
        maxDate={dueDate ? dayjs(dueDate).toDate() : undefined}
      />
      {(quickOptions.length > 0 || reminderDate) && (
        <div className="flex flex-wrap justify-end gap-1">
          {quickOptions.map((option) => {
            const value = option.getValue()
            // A reminder can't fire in the past: when the due date is soon, a
            // lead-time option (e.g. "1d before") can resolve before now, so
            // disable it rather than schedule a reminder that already elapsed.
            const isPast = !value || dayjs(value).isBefore(dayjs())
            return (
              <QuickPill
                key={option.label}
                disabled={isPast}
                onClick={() => onChange(value)}
              >
                {option.label}
              </QuickPill>
            )
          })}
          {reminderDate && (
            <QuickPill muted onClick={() => onChange(null)}>
              Clear
            </QuickPill>
          )}
        </div>
      )}
    </div>
  )
}

export default ReminderControl
